// extracted by mini-css-extract-plugin
export default {"main-image":"header_main-image__NfMIw"};